<template>
  <div class="player-history-container">
    <form action="">
      <select name="search-type" id="search-type" class="search-dropdown" v-model="searchType"
        @change="searchTerm = ''">
        <option value="player" default class="search-option">By Player</option>
        <option value="set" class="search-option">By Set</option>
      </select>
      <input type="text" v-model="searchTerm" class="search-term" autocomplete="false" maxlength="30" />
      <button :disabled="searchTerm.length < 3 || loadingStatus" @click="fetchData" class="search-button">
        Search
      </button>
    </form>
    <div class="search-instructions">
      Please enter search string (at least 3 characters). Search is case
      insensitive. Search term can be part of a name/set.
    </div>
    <div class="search-instructions">
      <b>As a trial, currently only sets starting with "B612" or containing the word "Friendly" will be displayed
        here.<br>
        Recommend setters of Friendlies to name their sets accordingly.</b>
    </div>
    <div v-if="loadingStatus">
      <wait-spinner-vue />
    </div>
    <div v-else-if="games.length > 0" class="results-container">
      <div v-if="searchResultString" v-html="searchResultString" class="search-result-string">
      </div>
      <div class="filter-container">
        <input type="text" v-model="filterString" @input="filterByFileName" class="filter-input" />
        <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="filter-icon" />
      </div>
      <table class="results-table">
        <tr>
          <th v-for="c in columns" :key="c.id" :class="c.className">{{ c.label }}</th>
        </tr>
        <tr v-for="n in showGames" :key="n._id">
          <td v-for="c in columns" :key="c.id">
            <span v-if="c.label === 'File Name'"> {{ n.fileName }} </span>
            <span v-if="c.label === 'Date'"> {{ n.gameStartTime }} </span>
            <a v-if="c.label === 'Game Link'" :href="getLink(n.gameId, n.gameType)" target="_blank">
              {{ "Link" }}
            </a>
            <span v-if="c.label === 'Reader'"> {{ n.readerName }} </span>
            <div v-if="c.label === 'Players'">
              <ol>
                <li v-for="(p, i) in n.players" :key="i">
                  {{ p.name }}
                </li>
              </ol>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { getGamesForPlayer, getGamesBySet } from "@/connectors";
import WaitSpinnerVue from "@/components/WaitSpinner.vue";

export default {
  name: "PlayerHistory",
  components: {
    WaitSpinnerVue,
  },
  data() {
    return {
      searchTerm: "",
      games: [],
      showGames: [],
      searchResultString: '',
      columns: [
        { label: "File Name", id: 0, className: "file-name" },
        { label: "Date", id: 1, className: "date" },
        { label: "Players", id: 4, className: "players" },
        { label: "Reader", id: 3, className: "reader" },
        { label: "Game Link", id: 2, className: "game-link" },
      ],
      pageNumber: 0,
      filterString: "",
      searchType: "player",
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      loadingStatus: false,
    };
  },
  methods: {
    async fetchData() {
      this.filterString = "";
      this.searchResultString = ``
      this.loadingStatus = true;
      if (this.searchType === 'player') {
        await this.fetchGamesForPlayer()
      } else {
        await this.fetchGamesForSet()
      }
      this.showGames = this.games;
      this.loadingStatus = false;
    },

    async fetchGamesForSet() {
      this.games = await getGamesBySet(this.searchTerm);
      this.games.forEach((g) => {
        const dateTime = new Date(g.gameStartTime.replace(" ", "T"));
        g.gameStartTime = `${String(dateTime.getDate()).padStart(2, 0)}-${this.monthNames[dateTime.getMonth()]
          }-${dateTime.getUTCFullYear()}`;
      });
      this.searchResultString = `Showing results for <b>sets</b> matching <b>"${this.searchTerm}"</b>.`
    },

    async fetchGamesForPlayer() {
      this.games = await getGamesForPlayer(this.searchTerm);
      this.games.forEach((g) => {
        const dateTime = new Date(g.gameStartTime.replace(" ", "T"));
        g.gameStartTime = `${String(dateTime.getDate()).padStart(2, 0)}-${this.monthNames[dateTime.getMonth()]
          }-${dateTime.getUTCFullYear()}`;
      });
      this.searchResultString = `Showing results for <b>players</b> matching <b>"${this.searchTerm}"</b>.`
    },
    getLink(id, type) {
      return `https://mimir-quiz-scorer.netlify.app/result/${type}/${id}`;
    },
    filterByFileName() {
      const searchPattern = this.filterString.split('').map(char => `.*${char}`).join('');
      const regex = new RegExp(searchPattern, 'i');
      this.showGames = this.games.filter((x) =>
        regex.test(x.fileName)
      );
    },
  },
};
</script>

<style scoped>
.player-history-container {
  padding-top: 20px;
}

button {
  cursor: pointer;
}

.results-container {
  margin: 20px 100px;
}

.search-result-string {
  font-size: 1.2rem;
}

@media (max-width: 900px) {
  .results-container {
    margin: 20px 5px;
  }
}

.results-table {
  width: 100%;
}

th {
  background-color: lightgray;
}

td {
  background-color: rgb(224, 230, 235);
}

td,
th {
  text-align: left;
  padding: 5px;
}

.search-term,
.search-button,
.search-dropdown,
.search-option {
  font-size: 1rem;
  padding: 8px;
  font-family: Nunito;
}

.search-dropdown,
.search-term {
  margin-right: 15px;
}

.search-instructions {
  font-size: 12px;
  margin-top: 6px;
}

ol {
  padding-left: 20px;
  margin: 0;
}

.filter-container {
  text-align: left;
}

.filter-icon {
  margin-left: 10px;
  color: gray;
}

.filter-input {
  padding: 5x;
  font-family: Nunito;
}
</style>